import { IUserProfileResponse } from 'api/components/User/types';

import { ALL_PROBLEM_ZONES, ProblemZone } from 'constants/user';
import { AUTH_TOKEN_NAME, AUTH_TOKEN_WELLFUNNEL_NAME } from 'constants/api';

import { getCookie } from 'helpers/cookie';

import { jwtDecode } from 'jwt-decode';

type TokenPayload = {
    user_id?: string | number;
    time?: string;
    token_type?: string;
};

const userAPIResponseTransformer = <T extends { problem_zones: ProblemZone[]; user_id: number }>(
    userData: T | IUserProfileResponse
) => {
    return {
        ...userData,
        problem_zones:
            !userData?.problem_zones?.length || userData?.problem_zones?.includes(ALL_PROBLEM_ZONES as ProblemZone)
                ? Object.values(ProblemZone)
                : userData.problem_zones,
    };
};

const safeJWTDecode = (token?: string | null): TokenPayload | null => {
    try {
        return token ? jwtDecode<TokenPayload>(token) : null;
    } catch {
        return null;
    }
};

// New token type: CWT token, JWT-token with user_id as string-type, JWT-token with token_type as string-type
const isNewTokenType = () => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get(AUTH_TOKEN_NAME);
    const authToken = url.searchParams.get(AUTH_TOKEN_WELLFUNNEL_NAME);
    const cookieToken = getCookie(AUTH_TOKEN_NAME);

    if (authToken && authToken !== 'null') return true;

    if (token) {
        const decoded = safeJWTDecode(token);

        return typeof decoded?.user_id === 'string';
    } else if (cookieToken) {
        const decoded = safeJWTDecode(cookieToken);

        return Boolean(decoded?.token_type);
    }

    return true;
};

const isJwtFormat = (token: string | null) => {
    return Boolean(safeJWTDecode(token));
};

export { userAPIResponseTransformer, isNewTokenType, isJwtFormat };
